function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M110.752 55.683l-81.988 47.269c-2.978 1.717-6.7-.43-6.7-3.862V4.55c0-3.435 3.722-5.582 6.7-3.864l81.988 47.27c2.978 1.718 2.978 6.01 0 7.727",
  fill: "#0AC700"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.4 54.09L2.524 71.817C1.403 72.46 0 71.657 0 70.367V34.916c0-1.287 1.402-2.093 2.523-1.45L33.4 51.193a1.668 1.668 0 010 2.898",
  fill: "#0AC700"
}), /*#__PURE__*/React.createElement("path", {
  d: "M69.935 44.03a5.716 5.716 0 002.495-7.676 5.717 5.717 0 00-7.68-2.493 5.714 5.714 0 00-2.493 7.675 5.714 5.714 0 007.678 2.495",
  fill: "#FFF"
}));

function SvgFishGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 113 104"
  }, props), _ref);
}

export default SvgFishGreen;